// extracted by mini-css-extract-plugin
export default {"input":"AddCategory_input__db0aP"};